import { MANAGE_SUBSCRIPTIONS_API } from 'modules/profile/manage-subscriptions/api/cancel-subscriptions-api'
import { ManageSubscriptionsApiInterface } from 'modules/profile/manage-subscriptions/types/manage-subscriptions-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import useSWR from 'swr'

interface UseManageSubscriptionsInterface extends SwrPaginationInterface {}

export function useManageSubscriptions({ limit, pagination }: UseManageSubscriptionsInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ManageSubscriptionsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  return useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${MANAGE_SUBSCRIPTIONS_API}/list?pagination[limit]=${limit}`
    } else if (user && pagination.startFromId && limit) {
      return `${MANAGE_SUBSCRIPTIONS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    }
  }, fetcher)
}
